import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import QiankunVue from 'qiankun-vue'

import 'normalize.css'

import { messages, dateTimeFormats } from '@/i18n/i18n'
import { getLocale, getSchoolInfo, setLocale } from '@/utils/utils'

import baiduAnalytics from 'vue-baidu-analytics'

import {
  Badge,
  Breadcrumb,
  Button,
  Checkbox,
  ConfigProvider,
  Dropdown,
  Form,
  Icon,
  Input,
  Layout,
  Menu,
  message,
  Modal,
  Progress,
  Upload,
  Tabs,
} from 'ant-design-vue'

Vue.use(QiankunVue)

Vue.use(VueI18n)

Vue.use(Badge)
Vue.use(Breadcrumb)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(ConfigProvider)
Vue.use(Dropdown)
Vue.use(Form)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Layout)
Vue.use(Menu)
Vue.use(Modal)
Vue.use(Progress)
Vue.use(Upload)
Vue.use(Tabs)

Vue.prototype.$info = Modal.info
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message

const qiankunVue = new QiankunVue([
  {
    name: 'app',
    entry: process.env.NODE_ENV === 'production' ? window.origin + '/micro/' : '//localhost:9091',
    activeRule: '/app',
  },
])

Vue.config.productionTip = false

let locale = getLocale()
if (!locale) {
  const systemLanguage = navigator.language
  if (systemLanguage === 'en') {
    locale = 'en'
    setLocale('en')
    store.commit('setLocale', 'en')
  } else {
    locale = 'zh'
    setLocale('zh')
    store.commit('setLocale', 'zh')
  }
}

const schoolId = getSchoolInfo()?.schoolId

const siteId = {
  1: ['cd0efe6b2f33f179543a00bfdd66450b'],
  2: ['cc17fe42f7b4e822b88d0da551dd1f5a'],
  3: ['b14d3e8d71d473314c627697c4a15a9f'],
  4: ['b848764dd8b121d1315e7338d6cb91c6'],
}

if (process.env.VUE_APP_ENV === 'PRODUCTION' && [1, 2, 3, 4].includes(schoolId)) {
  Vue.use(baiduAnalytics, {
    router: router,
    siteIdList: siteId[schoolId],
    isDebug: false,
  })
}

const i18n = new VueI18n({
  locale,
  dateTimeFormats,
  fallbackLocale: 'zh',
  messages,
})

new Vue({
  router,
  store,
  i18n,
  qiankunVue,
  render: h => h(App),
}).$mount('#main')
